import { useEffect, useState } from "react";
import { FileText } from "lucide-react";

import { FileComponentProps } from "../../types";
import { base64ToBuffer, getFileSizeFromBase64 } from "../../utils";
import { FileThumbnail } from "../FileThumbnail";
import { FilePreviewWrapper } from "../FilePreviewWrapper";

import { TextPreview } from "./TextPreview";

const getFileTitle = (isJson: boolean, isCsv: boolean): string => {
  if (isJson) {
    return "JSON File";
  }

  if (isCsv) {
    return "CSV File";
  }

  return "Text File";
};

export const TextDisplay = ({
  data,
  detectedFile,
  isViewing,
  setIsViewing,
}: FileComponentProps) => {
  const [text, setText] = useState<string>("");

  useEffect(() => {
    try {
      const buffer = base64ToBuffer(data);
      setText(new TextDecoder().decode(buffer));
    } catch {
      setText("Unable to decode text content");
    }
  }, [data]);

  const isJson = detectedFile.type === "json";
  const isCsv = detectedFile.type === "csv";

  return (
    <div className="group relative">
      <div className="cursor-pointer rounded p-2 transition-colors hover:bg-gray-100">
        <FilePreviewWrapper
          isViewing={isViewing}
          setIsViewing={setIsViewing}
          trigger={
            <div>
              <FileThumbnail
                icon={<FileText className="h-6 w-6 text-gray-600" />}
                title={getFileTitle(isJson, isCsv)}
                subtitle={`${
                  detectedFile.extension?.toUpperCase() || "TXT"
                } • ${getFileSizeFromBase64(data)}`}
              />
            </div>
          }
        >
          <TextPreview text={text} detectedFile={detectedFile} />
        </FilePreviewWrapper>
      </div>
    </div>
  );
};
